import mySuxApi from '../dataSources/mySuxApi';
import asSofologist from '../dataSources/asSofologist';
import axios from '../dataSources/default';

import { isSofologist } from '../AuthService';

import { config } from '../../config';
import store from '../../store';

const URLS = config.URLS;

export function registerCardPayment(userGuid, orderIdx, result) {
  const userId = store.getState().user.userId;

  return mySuxApi.post(`${URLS.MY_SOFOLOGY_API}${userGuid}/Payment/Update/${orderIdx}/${userId}`, result);
}

export function registerInPersonPayment(orderIdx, paymentType, amount) {
  const state = store.getState();
  const sofologist = state.sofologist;
  const { userGuid, userId } = state.user;
  // ensure is sofologist with api call
  return isSofologist().then((res) => {
    if (!res.data) return Promise.reject('Unauthorized');
    const payment = {
      actionedBy: sofologist.login,
      location: sofologist.location,
      paymentType,
      amount
    };
    return asSofologist.post(`${URLS.MY_SOFOLOGY_API}/impersonation/${userGuid}/Payment/Update/${orderIdx}/${userId}`, payment);
  });
}


export function setUpPayPalPayment(order, user, paymentAmount) {
  const phone = user.data.phoneNumbers.find(num => num.primary).number || user.data.phoneNumbers[0].number;
  const userData = user.data;
  const address = user.data.addresses.find(a => a.type.toLowerCase() === 'delivery') || user.data.addresses[0];
  const shippingAddress = {
    recipient_name: `${(userData.firstName || '')} ${(userData.surname || '')}`,
    line1: address.line1 || '',
    line2: address.line3 || '',
    city: address.line2 || '',
    country_code: 'GB',
    postal_code: address.postCode,
    phone,
    state: ''
  };
  const body = {
    vendorTxCode: `HQ-INTERNET-${order.orderRef}-${order.orderNo}-${Date.now()}`,
    shippingAddress,
    paymentAmount
  };
  return axios.post(`${URLS.SOP_API}/payments/setup`, body).then(res => res.data);
}

export function executePayPalPayment(payerID, paymentID) {
  const body = { payerID, paymentID };
  return axios.post(`${URLS.SOP_API}/payments/execute`, body)
    .catch((res) => {
      if (res && res.response && res.response.data) return Promise.reject(res.response.data);
      return Promise.reject(res);
    });
}

export function registerPayPalPayment(orderIdx, transaction) {
  const state = store.getState();
  const { userGuid, userId } = state.user;
  const body = {
    TransactionId: transaction.id,
    VendorTxCode: transaction.transactions[0].custom,
    TotalAmount: transaction.transactions.reduce((acc, curr) => acc + parseFloat(curr.amount.total, 10), 0),
    PaymentMethod: transaction.payer.payment_method,
    State: transaction.state,
    Intent: transaction.intent
  };

  return mySuxApi.post(`${URLS.MY_SOFOLOGY_API}/${userGuid}/Payment/Update/PayPal/${orderIdx}/${userId}`, body);
}


// WEBPACK FOOTER //
// ./src/services/payment/PaymentService.js